<div class="relative w-full">
  @if (label()) {
    <label
      class="absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700"
      [for]="fileInputId"
      >{{ label() }}</label
    >
  }
  <div class="group border border-neutral-700 rounded-lg flex overflow-hidden">
    <div class="text-neutral-500 text-sm py-4 grow px-4 flex justify-between">
      @if (hasFiles) {
        <span>{{ fileDisplayName }}</span>
        <button
          class="cursor-pointer px-2"
          type="button"
          (click)="clearFiles()"
          [disabled]="isDisabled">
          <fa-icon size="lg" class="text-neutral-500" [icon]="faXmark" />
        </button>
      } @else {
        <span>{{ placeholder() }}</span>
      }
    </div>

    <button
      [disabled]="isDisabled"
      class="relative cursor-pointer bg-primary-700 text-sm text-white font-medium py-4 px-3 hover:bg-primary-80 disabled:hover:bg-primary disabled:opacity-50 disabled:cursor-not-allowed">
      <input
        #fileInput
        type="file"
        [id]="fileInputId"
        [disabled]="isDisabled"
        (change)="onFileChange($event)"
        (blur)="onBlur()"
        [accept]="accept()"
        class="absolute w-full h-full inset-0 opacity-0 cursor-pointer disabled:cursor-not-allowed" />
      Choose File
    </button>
  </div>
</div>
